var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process"},_vm._l((_vm.data),function(item,index){return _c('ProcessItem',{key:index,attrs:{"info":item,"showIcon":index != _vm.data.length-1}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }